import { RootState } from '@/store/store';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { Api } from '@/api/api';

export interface User {
  username: string;
  profilePicture: string;
  groups: string[];
  oid: string;
}

export interface UserState {
  user: User;
}

export const state: UserState = {
  user: {
    username: '',
    profilePicture: '',
    groups: [],
    oid: ''
  },
};

export const getters: GetterTree<UserState, RootState> = {
  loggedIn: state => !!state.user.username,
  getUserName: state => state.user.username,
  getUserGroups: state => state.user.groups,
  getUserDetails: state => state.user
};

export const mutations: MutationTree<UserState> = {
  SET_USER: (state, user) => {
    state.user.username = user.username;
    state.user.groups = user.groups;
    state.user.oid = user.oid;
  }
};

export const actions: ActionTree<UserState, RootState> = {
  LOGIN() {
    Api.Auth.login();
  },
  LOGOUT() {
    localStorage.removeItem('token');
    Api.Auth.logout();
  }
};

export const UserStore: Module<UserState, RootState> = {
  state,
  getters,
  mutations,
  actions
};
